export default {
	state: {
		currentAccount: null,
		loggedIn: false,
		accounts: []
	},
	mutations: {
		SET_CURRENT_USER(state, account) {
			state.currentAccount = account;
			state.loggedIn = true;
		},
		ADD_ACCOUNT(state, account) {
			state.accounts.push(account);
		},
		REMOVE_ACCOUNT(state, userId) {
			state.accounts = state.accounts.filter(account => account.user.id !== userId);
		},
		SAVE_ACCOUNT(state, account) {
			state.currentAccount.user = account.user;
			state.accounts.forEach(row => {
				if (row.user.id === account.user.id) {
					row.user = account.user;
				}
			})
		},
		LOGOUT(state) {
			state.currentAccount = null;
			state.loggedIn = false;
		}
	},
	actions: {
		loginAccount({ commit }, account) {
			commit('ADD_ACCOUNT', account);
		},
		switchAccount({ commit }, account) {
			commit('SET_CURRENT_USER', account);
		},
		addAccount({ commit }, account) {
			commit('ADD_ACCOUNT', account);
		},
		removeAccount({ commit }, userId) {
			commit('REMOVE_ACCOUNT', userId);
		},
		saveAccount({ commit }, account) {
			commit('SAVE_ACCOUNT', account);
		},
		logout({ commit }) {
			commit('LOGOUT');
		}
	},
	getters: {
		currentAccount: state => state.currentAccount,
		loggedIn: state => state.loggedIn,
		accounts: state => state.accounts
	}
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js